import { render, staticRenderFns } from "./TutorialComponent.vue?vue&type=template&id=c5289c36&scoped=true&"
import script from "./TutorialComponent.vue?vue&type=script&lang=js&"
export * from "./TutorialComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5289c36",
  null
  
)

export default component.exports